import httpClient from './httpClient';

const prefix = '/rental-customers';

export default {
  async get(page, perpage) {
    const res = await httpClient({ requiresAuth: true }).get(prefix, { params: { page, perpage } });
    return res.data;
  },
  async show(id) {
    const res = await httpClient({ requiresAuth: true }).get(`${prefix}/${id}`);
    return res.data;
  },
  async post(data) {
    const res = await httpClient({ requiresAuth: true }).post(prefix, data);
    return res.data;
  },
  async update(id, data) {
    const res = await httpClient({ requiresAuth: true }).put(`${prefix}/${id}`, data);
    return res.data;
  },
  async delete(id) {
    const res = await httpClient({ requiresAuth: true }).delete(`${prefix}/${id}`);
    return res.data;
  },
  async addVehicle(rental_customer_id, body) {
    const res = await httpClient({ requiresAuth: true }).post(`/rental-vehicle/${rental_customer_id}`, body);
    return res.data;
  },
  async addDocument(rental_customer_id, body) {
    const res = await httpClient({ requiresAuth: true }).post(`/rental-document/${rental_customer_id}`, body);
    return res.data;
  }
};
